export interface ItemReceiptLineConstructor {
  poIndex: Nullable<number> // "#" column — item.item.PO[0]
  itemName: string
  receiveQuantity: string // raw API string; formatted by the View
}

export class ItemReceiptLine {
  readonly poIndex: Nullable<number>
  readonly itemName: string
  readonly receiveQuantity: string

  constructor(data: ItemReceiptLineConstructor) {
    this.poIndex = data.poIndex
    this.itemName = data.itemName
    this.receiveQuantity = data.receiveQuantity
  }
}
